var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPotionBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_8605)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8635 15.2303C25.8416 13.9477 24.6402 13.0599 23.6384 12.7699C18.8463 11.3598 16.9252 12.9056 16.2331 12.1943C16.0419 12.0145 15.9116 11.7795 15.8604 11.522C15.8092 11.2646 15.8396 10.9976 15.9474 10.7584L13.5145 12.5268L10.8502 13.9535C11.1124 13.9629 11.3651 14.054 11.5731 14.2139C11.7811 14.3738 11.934 14.5947 12.0105 14.8456C12.3444 15.7686 10.099 16.8031 9.22928 21.7245C9.00365 23.0142 9.46855 25.021 10.6195 26.8548C12.7665 30.2626 17.2855 33.0819 24.1222 29.6732C30.9007 24.542 29.5025 18.5577 26.8635 15.2303ZM10.8275 24.8961C8.85792 19.4261 12.6587 16.0189 12.7476 15.1477C12.8365 14.2766 12.0902 13.4461 12.0902 13.4461L14.7067 11.8191C14.9532 12.3998 15.3988 12.8736 15.9633 13.1553C16.7745 13.468 21.5153 11.5798 25.5574 15.766C29.5994 19.9522 27.3962 25.11 23.0726 28.2417C18.3448 30.7239 12.7701 30.3866 10.813 24.9045L10.8275 24.8961Z",
    fill: "url(#paint0_linear_490_8605)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83434 11.8384C6.81518 12.3346 8.33081 14.0355 8.97207 14.3395C10.4082 15.0288 16.6737 10.6643 16.9071 9.59817C17.0785 8.78606 15.9024 6.56413 15.5663 6.32644C15.2302 6.08876 6.83434 11.8384 6.83434 11.8384Z",
    fill: "url(#paint1_linear_490_8605)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83493 11.8378C7.11626 12.762 16.2925 7.78426 15.5533 6.3191C14.8141 4.85394 6.20837 9.80307 6.83493 11.8378Z",
    fill: "#EBC3D3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17062 10.9167C8.36677 11.5505 14.5206 7.95879 14.0185 6.96313C13.5164 5.96746 7.74441 9.52307 8.17062 10.9167Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37879 11.781C7.34696 12.1197 8.60362 13.2375 9.57706 13.7137C10.5505 14.1898 16.2308 10.6434 16.0278 9.17433C15.8248 7.70522 15.3922 8.14903 13.1795 9.41681C10.9669 10.6846 8.37879 11.781 8.37879 11.781Z",
    fill: "#9A376D"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.20261 11.4609C8.84253 11.5766 10.5503 12.6524 12.0964 12.5407C13.6425 12.4291 14.9909 9.9333 14.6335 8.65038C14.623 8.63219 11.1828 10.5214 9.20261 11.4609Z",
    fill: "url(#paint2_linear_490_8605)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9581 9.17601C10.3252 10.4146 13.3583 8.95457 14.1665 8.2454C14.9747 7.53624 15.7188 6.48083 15.4836 6.32555C15.3295 6.23504 14.0727 7.43604 13.289 8.14561C12.8785 8.52989 12.4329 8.87487 11.9581 9.17601Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3524 8.35173C16.0241 8.46367 15.8989 9.82637 15.7395 10.4326C15.5801 11.0388 16.6875 9.98231 16.7646 9.29256C16.8418 8.6028 16.5241 8.29625 16.3524 8.35173Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91751 11.4944C6.83462 11.8382 7.23173 11.9631 7.71203 11.8119C8.19233 11.6607 7.46367 11.1549 7.27264 11.2021C7.12937 11.2646 7.00639 11.3659 6.91751 11.4944Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0908 13.9072C10.337 14.2066 9.09896 12.5831 9.16459 12.1086C9.23022 11.6342 13.1964 12.2356 13.0244 12.6939C12.8523 13.1521 11.0908 13.9072 11.0908 13.9072Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31319 12.3139C7.35247 12.592 8.24885 13.6656 8.74919 14.0365C8.8848 14.1558 9.05031 14.2359 9.22798 14.2684C9.40565 14.3008 9.5888 14.2843 9.75781 14.2206C9.91133 14.1757 8.58897 13.28 8.03807 12.788C7.28149 12.0993 7.28149 12.0993 7.31319 12.3139Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08058 10.7937C6.80074 11.4937 6.69321 11.8032 8.5068 9.97023C10.3204 8.13727 12.872 6.80962 13.526 6.69884C14.18 6.58806 14.3535 7.15737 15.1947 6.37093C16.0359 5.5845 13.147 6.18516 10.4226 7.92785C7.69829 9.67055 7.08058 10.7937 7.08058 10.7937Z",
    fill: "#9A376D"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75418 10.8953C7.38476 9.22467 5.9293 7.62644 4.39368 6.10712C4.39368 6.10712 8.77139 0.83393 13.2429 2.10895C13.2429 2.10895 13.011 5.26991 14.0863 7.4433C14.0612 7.43352 12.4225 9.32562 8.75418 10.8953Z",
    fill: "url(#paint3_linear_490_8605)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2138 2.36795C12.7455 4.75822 3.93778 7.06369 4.35268 5.917C4.76758 4.7703 6.07028 3.70771 7.55907 2.89182C7.80844 2.8991 8.05653 2.85342 8.28696 2.75778C8.45903 2.6366 8.61145 2.4897 8.7389 2.32222L8.89171 2.23399C8.89171 2.23399 9.28032 2.90708 9.57421 1.97093C11.6325 1.26766 13.4342 1.21222 13.2138 2.36795Z",
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54441 10.5405C9.54441 10.5405 6.51119 6.69837 6.56485 5.99308C6.61851 5.2878 8.65846 3.14952 10.5834 2.32439C12.5083 1.49926 13.2342 2.21045 13.2342 2.21045C12.7133 2.05655 12.1638 2.02512 11.6288 2.11862C11.0937 2.21211 10.5875 2.42801 10.1496 2.74945C8.55582 3.85397 6.88051 5.26266 7.07434 6.07732C7.26816 6.89197 10.0051 10.3133 10.0051 10.3133L9.54441 10.5405Z",
    fill: "#B10053"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8186 9.88269C10.8186 9.88269 8.58887 6.5081 8.66158 5.39888C8.73428 4.28966 13.0656 2.75919 13.0656 2.75919C13.0656 2.75919 9.26785 4.3988 8.92327 5.306C8.5787 6.2132 11.3684 9.54101 11.3684 9.54101L10.8186 9.88269Z",
    fill: "#B10053"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3235 8.89267C12.3235 8.89267 10.8169 6.99738 11.6022 5.46707C12.3874 3.93676 13.3271 4.79134 13.3271 4.79134L13.4514 5.54429C13.4514 5.54429 12.4901 4.64395 11.8191 5.72508C11.148 6.80622 12.5449 8.75516 12.5449 8.75516L12.3235 8.89267Z",
    fill: "#B10053"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31462 8.09252C8.31462 8.09252 6.77894 6.68458 6.56429 5.99352C6.34965 5.30246 9.54807 3.17934 9.54807 3.17934C9.54807 3.17934 7.27439 4.90439 7.0635 5.87509C6.91059 6.5261 8.31462 8.09252 8.31462 8.09252Z",
    fill: "#97001A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5274 6.9996C9.5274 6.9996 8.48357 5.69578 8.7391 5.1553C8.99464 4.61483 10.5142 4.02861 10.5142 4.02861C10.5142 4.02861 9.10972 4.71333 8.9232 5.30612C8.73668 5.89892 9.5274 6.9996 9.5274 6.9996Z",
    fill: "#97001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56686 5.66702C4.2312 6.00149 5.8682 6.05569 6.21737 5.94627C6.56654 5.83685 7.22499 4.73388 7.70464 4.32112C8.1843 3.90836 5.02746 5.18764 4.56686 5.66702Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10056 5.75205C7.58054 5.70097 8.05389 5.60002 8.51295 5.45082C8.63328 5.32314 8.93026 4.84605 9.10681 4.58889C9.28336 4.33172 7.95611 4.32669 7.10056 5.75205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13014 5.24438C10.0425 4.87518 10.9316 4.45097 11.7925 3.97408C12.1716 3.77225 12.508 3.49895 12.7832 3.16927C12.7832 3.16927 10.4257 3.62322 9.13014 5.24438Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89623 5.54459C9.03644 5.45927 9.1605 5.34988 9.26269 5.22144C9.28245 5.17097 9.28938 5.11638 9.28287 5.06258C9.27635 5.00877 9.25659 4.95741 9.22536 4.91312C9.04371 5.07752 8.92696 5.30153 8.89623 5.54459Z",
    fill: "#FFA457"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11149 6.22591C7.11149 6.22591 7.40476 5.96927 7.34928 5.79755C7.2938 5.62584 7.1782 5.64407 7.1782 5.64407C7.1782 5.64407 6.99392 5.80383 7.11149 6.22591Z",
    fill: "#FFA457"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.451 9.38145C11.451 9.38145 9.49236 6.72841 9.29314 6.10606C9.09391 5.48372 10.6773 4.73931 11.6531 4.2196C12.6289 3.69989 11.5098 4.34114 11.3344 5.7765C11.1589 7.21186 12.122 8.64475 12.0814 8.87682C12.0407 9.10889 11.451 9.38145 11.451 9.38145Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50928 6.07383C7.38321 6.19998 8.4298 8.23958 9.54579 9.36591C10.6618 10.4922 10.2827 9.25581 10.1667 8.95409C10.0507 8.65237 8.66583 6.24534 8.60401 5.9366C8.54219 5.62787 7.50928 6.07383 7.50928 6.07383Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44722 6.09964C6.3674 5.96139 4.91082 6.40455 4.95576 6.43197C5.00069 6.45939 8.04958 9.84128 8.4914 10.178C8.93323 10.5148 7.69418 8.4359 6.44722 6.09964Z",
    fill: "#D42F55"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9876 7.78126C11.9876 7.78126 11.6164 6.6761 11.7667 6.04595C11.7919 5.88175 11.8551 5.72569 11.9512 5.59019C12.0473 5.4547 12.1737 5.34351 12.3203 5.26548C12.3203 5.26548 11.8704 5.32637 11.6685 6.10266C11.5867 6.68208 11.6989 7.27228 11.9876 7.78126Z",
    fill: "#FF6500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5025 8.42002C10.5025 8.42002 9.41587 6.62186 9.21068 6.18245C9.0055 5.74303 8.90298 5.54026 8.90298 5.54026C8.90298 5.54026 8.85705 6.34296 10.5025 8.42002Z",
    fill: "#FF6500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89271 2.25279L9.36499 2.40702C9.36499 2.40702 9.14381 2.70451 8.89271 2.25279Z",
    fill: "#E23100"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55835 2.89185C7.98972 2.8026 8.39245 2.6084 8.73091 2.32645C8.62305 2.53495 8.45041 2.70281 8.23896 2.80477C8.0275 2.90674 7.78866 2.93729 7.55835 2.89185Z",
    fill: "#E23100"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8313 2.07476C12.9696 2.18274 13.0919 2.30974 13.1946 2.45198C13.2076 2.57292 13.213 2.69454 13.2108 2.81615C13.2108 2.81615 13.2406 2.24594 13.2347 2.21053C13.1052 2.15173 12.97 2.10624 12.8313 2.07476Z",
    fill: "#97001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23283 10.2596C8.23283 10.2596 8.91491 10.8361 11.4225 9.33976C13.9302 7.84347 13.835 6.94761 13.835 6.94761L14.0508 7.43908C14.0508 7.43908 12.4118 9.38955 8.74375 10.9009L8.23283 10.2596Z",
    fill: "#D42F55"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.0729 28.2419C18.3535 30.7386 12.7789 30.4013 10.8217 24.9192C10.3686 23.7053 10.1885 22.4064 10.2941 21.115C10.5646 17.8444 12.6857 15.8048 12.7479 15.1479C12.8295 14.281 12.0906 13.4463 12.0906 13.4463L14.707 11.8193C14.9535 12.4 15.3991 12.8738 15.9636 13.1555C16.5879 13.3966 19.556 12.3282 22.7301 13.7507C23.7934 14.2346 24.7534 14.9189 25.5577 15.7662C29.5924 19.9566 27.3966 25.1101 23.0729 28.2419Z",
    fill: "url(#paint4_radial_490_8605)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0727 28.2416C18.3533 30.7384 12.7787 30.401 10.8216 24.919C10.3684 23.705 10.1883 22.4061 10.2939 21.1147L17.9381 19.3986L22.7202 13.7755C23.7834 14.2594 24.7435 14.9437 25.5477 15.791C29.5923 19.9564 27.3964 25.1099 23.0727 28.2416Z",
    fill: "url(#paint5_linear_490_8605)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3419 22.9793C10.2856 21.1005 15.2496 21.4557 19.9088 23.35C24.568 25.2442 24.473 21.685 24.241 18.855C24.009 16.0249 26.7473 21.0366 26.2428 23.4817C25.7383 25.9269 28.3689 21.8371 27.3071 18.6032C26.2453 15.3693 22.6973 13.7697 22.6973 13.7697C22.6973 13.7697 24.5803 15.3506 23.7168 16.6447C22.8534 17.9388 16.7376 20.2182 14.0787 20.6375C11.4198 21.0569 10.2711 21.1089 10.2711 21.1089C10.2263 21.7331 10.25 22.3603 10.3419 22.9793Z",
    fill: "#9A7AFF"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5854 20.6457C8.57525 21.7432 15.3332 21.475 20.9188 18.7644C26.5043 16.0537 23.2296 13.8016 22.0531 13.4863C20.8767 13.1711 16.9725 18.1806 14.875 19.673C12.7774 21.1653 11.3418 20.2332 10.5854 20.6457Z",
    fill: "url(#paint6_linear_490_8605)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8712 29.2609C9.91085 25.5176 20.8202 26.9614 23.5665 25.9289C26.3127 24.8964 27.0058 23.6182 27.0058 23.6182C27.0058 23.6182 25.2649 27.3835 21.871 28.79C18.4772 30.1964 14.8712 29.2609 14.8712 29.2609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4408 26.3278C11.4408 26.3278 15.8985 32.4522 22.8723 28.13C29.8462 23.8077 26.609 17.0999 26.609 17.0999C26.609 17.0999 30.8526 23.6099 23.1585 28.3819C15.4644 33.154 11.4408 26.3278 11.4408 26.3278Z",
    fill: "#9A3792"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9912 28.5894C24.1606 28.8312 26.8068 25.6929 27.7458 23.1181C28.6848 20.5434 29.576 25.4815 24.9912 28.5894Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79434 24.5178C10.4963 26.0529 10.0985 21.5576 10.1192 20.2407C10.1399 18.9238 8.67498 22.0496 9.79434 24.5178Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2215 19.6528C9.97452 19.7712 10.1173 18.8253 10.3277 18.6941C10.5382 18.5629 10.5445 19.5149 10.2215 19.6528Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3272 12.8674C21.997 13.1356 24.1277 14.1709 25.2969 15.2131C26.4662 16.2553 26.2787 14.981 25.6136 14.1232C24.9485 13.2653 22.8936 12.3948 22.3272 12.8674Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8677 15.5395C12.698 14.6332 12.6517 16.0571 14.9721 15.3625C17.2926 14.668 16.914 13.1887 16.2859 12.4453C16.104 12.2126 15.9781 11.9412 15.918 11.652C15.8579 11.3628 15.8651 11.0637 15.9392 10.7778C14.4605 12.1506 12.7332 13.2286 10.8502 13.9536C10.8502 13.9536 12.1696 14.2979 11.8677 15.5395Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M16.0063 29.1106C16.0063 29.1106 11.832 28.804 10.7913 23.6321C10.0343 19.8002 11.7825 17.4423 11.7825 17.4423C11.7825 17.4423 12.6675 16.7906 14.9559 20.2332C17.2442 23.6758 17.6385 28.207 16.0063 29.1106Z",
    fill: "url(#paint7_linear_490_8605)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3477 21.244C15.0248 21.032 17.6535 20.4108 20.1424 19.4021C24.5265 17.6859 24.0692 15.6166 24.0692 15.6166C24.0692 15.6166 23.6481 17.1306 20.2576 18.8456C16.8672 20.5605 12.3477 21.244 12.3477 21.244Z",
    fill: "#59C7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4601 19.9998C18.0848 19.9884 19.7047 19.0047 20.6612 18.7289C21.6178 18.4532 21.1797 18.9632 20.8349 19.1138C20.4901 19.2644 18.4601 19.9998 18.4601 19.9998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6884 20.9548C13.8777 21.0881 19.3641 23.0288 21.8828 23.7867C24.4015 24.5446 23.9576 20.8181 23.918 19.0607C23.8795 18.1553 23.9329 17.2484 24.0774 16.3539C23.0909 17.5591 21.8688 18.5502 20.4859 19.2667C18.353 20.2944 14.6884 20.9548 14.6884 20.9548Z",
    fill: "#9A7AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1241 29.6672C17.2801 33.0801 12.7683 30.2566 10.6213 26.8488C10.8164 27.1194 15.4038 34.0567 23.7742 29.5151C32.3215 24.8762 26.8638 15.23 26.8638 15.23C29.5028 18.5575 30.901 24.5418 24.1241 29.6672Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8619 21.2812C11.5068 21.4428 14.259 24.6807 16.7754 26.09C19.2918 27.4993 17.2574 24.5553 18.5934 23.9537C19.9294 23.3522 20.9223 25.1559 22.8187 25.2981C24.7151 25.4402 21.8825 28.2642 20.3491 27.6165C18.8158 26.9688 20.2085 26.2133 20.4639 26.3617C20.7194 26.5101 22.9322 26.4357 20.8871 25.3218C18.8421 24.208 18.8086 25.5953 18.8087 27.0069C18.8087 28.4186 16.8065 28.3957 13.6994 26.2068C10.5923 24.018 10.2339 21.9352 10.7985 21.5268C11.3631 21.1183 14.48 21.1816 18.0478 20.3199C21.6156 19.4583 18.6275 22.1391 15.8619 21.2812Z",
    fill: "#9A7AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2314 29.397C17.3952 29.1814 20.8043 27.2131 24.1176 25.8435C27.4309 24.4739 24.6897 27.9436 20.2314 29.397Z",
    fill: "white"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 13.9952C16.6151 15.2002 19.4361 17.0109 21.609 17.1195C23.782 17.2282 22.666 14.4718 21.4289 13.7744C20.1919 13.0769 18.2873 13.6769 17.9375 13.9952Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6271 17.7791C12.1355 16.9278 11.3157 18.7594 11.5628 19.3638C11.8098 19.9683 13.0734 18.5354 12.6271 17.7791Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2685 12.635C16.9016 12.9827 19.1797 12.5843 20.611 12.7864C22.0423 12.9884 19.4836 11.6908 17.2685 12.635Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8044 28.7421C11.4407 27.6812 15.2093 31.3267 18.8765 31.0238C22.5437 30.7208 24.0691 28.4139 24.0447 28.1029C24.0204 27.7919 21.3367 29.5209 18.9205 29.9069C16.5043 30.2928 13.8044 28.7421 13.8044 28.7421Z",
    fill: "#75FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0053 17.0019C24.2365 16.2074 24.2637 15.3675 24.0845 14.5597C24.0821 14.4883 26.8724 16.1955 27.1073 18.6358C27.3423 21.0761 27.0943 21.554 26.5043 21.0699C25.9144 20.5859 24.9927 17.4602 24.229 17.9691C23.4652 18.478 24.5557 21.8457 23.4526 22.7833C22.3494 23.721 21.2784 21.8071 21.4556 20.3999C21.6327 18.9926 22.2516 20.7116 22.7005 19.9431C23.1494 19.1745 22.6825 18.2313 20.0517 19.6823C17.4208 21.1333 19.7267 22.4216 20.2504 21.1442C20.7742 19.8667 21.4186 23.1087 21.092 23.3749C20.7655 23.641 19.5846 23.0324 16.8983 22.0851C14.2119 21.1377 13.5958 21.5662 13.4614 22.745C13.327 23.9238 16.6787 25.7968 15.7829 26.4886C14.8871 27.1804 12.6467 25.7282 11.5068 23.922C10.367 22.1157 10.2652 21.9562 10.6081 21.6175C10.951 21.2788 15.8118 21.388 19.378 19.7171C22.9443 18.0462 24.0053 17.0019 24.0053 17.0019Z",
    fill: "#9A7AFF"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4507 25.7738C11.4661 25.7068 12.5148 27.4056 13.1574 27.5439C13.8 27.6823 13.3426 25.8313 12.4507 25.7738Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_8605",
    x1: 24.0982,
    y1: 29.7436,
    x2: 13.3854,
    y2: 12.4105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E5DDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DABBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D3A7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D19FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#BE92C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A57FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9272A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#886B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#846898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_490_8605",
    x1: 7.77275,
    y1: 13.5871,
    x2: 16.6788,
    y2: 8.0826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9386AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D90B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ADA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C4BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_490_8605",
    x1: 9.81573,
    y1: 12.6704,
    x2: 15.0786,
    y2: 9.41771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D83303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5C11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_490_8605",
    x1: 5.94908,
    y1: 8.66183,
    x2: 14.1294,
    y2: 3.60596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D83303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5C11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_490_8605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3773 22.2806) rotate(-31.7184) scale(9.604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E3DDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DBD1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D8CDD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D4C5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C7ACC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BE99C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B98FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_490_8605",
    x1: 23.0377,
    y1: 28.2991,
    x2: 16.3113,
    y2: 17.4159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4A9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6540FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_490_8605",
    x1: 11.0914,
    y1: 22.5296,
    x2: 23.7265,
    y2: 14.7204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_490_8605",
    x1: 11.0016,
    y1: 25.1105,
    x2: 16.0142,
    y2: 22.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_8605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPotionBlue);
export default __webpack_public_path__ + "static/media/icon-potion-blue.3a3eec8bc88b5e41150fe206afbb13f7.svg";
export { ForwardRef as ReactComponent };